var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtRange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75.622 79.66v120.99H52.036v-96.256l-22.427.497v-17.01zm61.626 99.562v21.427H113.91v-21.427zm45.097 0v21.427h-23.338v-21.427zm68.102-99.562v120.99h-23.586v-96.256l-22.426.497v-17.01z"
})));
export default SvgQtRange;